import { makeStyles, TextField, Typography } from '@material-ui/core';
import React from 'react';
import Box from '../../../UI';

export default function Parameters({ copy, onChange }) {
	const classes = useStyles();
	const { letterhead, fixed, par1, purchasePrice, conclusion } = copy;

	return (
		<div className={classes.root}>
			<Box mb={2}>
				<Typography variant="h5"><strong>Parameters</strong></Typography>
			</Box>

			<TextField
				id="outlined-multiline-static"
				label="Letterhead"
				multiline
				rows="2"
				value={letterhead}
				variant="outlined"
				className={classes.input}
				name="letterhead"
				onChange={onChange}
				helperText='Please enter a comma separated list'
			/>
			<TextField
				id="outlined-multiline-static"
				label="Jurisdiction"
				multiline
				rows="1"
				value={fixed}
				variant="outlined"
				className={classes.input}
				name="fixed"
				onChange={onChange}
				disabled
			/>
			<TextField
				id="outlined-multiline-static"
				label="Information on the Potential Acquirer"
				multiline
				rows="4"
				value={par1}
				variant="outlined"
				className={classes.input}
				name="par1"
				onChange={onChange}
			/>
			<TextField
				id="outlined-multiline-static"
				label="Purchase Price"
				multiline
				rows="1"
				value={purchasePrice}
				variant="outlined"
				className={classes.input}
				name="purchasePrice"
				onChange={onChange}
			/>
			<TextField
				id="outlined-multiline-static"
				label="Additional Conditions"
				multiline
				rows="4"
				value={conclusion}
				variant="outlined"
				className={classes.input}
				name="conclusion"
				onChange={onChange}
			/>
		</div>
	);
}

const useStyles = makeStyles(theme => ({
	root: {
		paddingRight: theme.spacing(4),
	},
	input: {
		width: '100%',
		marginBottom: theme.spacing(4),
		background: 'white',
	},
}));
